import type { SubBasinResult } from "../engine/engine.ts";
import { useT } from "../i18n/hooks.ts";
import type { CalculationOptions } from "../model/calculationOptions.ts";
import type { DailySeries, ProjectSeries } from "../model/dailySeries.ts";
import type { EvalHidProject } from "../model/types.ts";
import { CalculationResults } from "./CalculationResults.tsx";
import type { ResultLevel, ResultSelection } from "./resultSelection.ts";

export function ResultsPanel({
  results,
  project,
  onChangeProject,
  dates,
  years,
  pumpingSeries,
  series,
  calculationOptions,
  selection,
  onSelect,
  onLevelChange,
  onClose,
}: {
  results: SubBasinResult[];
  project: EvalHidProject;
  onChangeProject: (project: EvalHidProject) => void;
  dates: string[];
  years: number;
  pumpingSeries: DailySeries | null;
  /** For `useSubBasinDetail` (useCalculation.ts) — the on-demand recompute of a single sub-basin's full detail, see CalculationResults.tsx's own use of it. */
  series: ProjectSeries;
  calculationOptions: CalculationOptions | null;
  selection: ResultSelection | null;
  onSelect: (selection: ResultSelection) => void;
  onLevelChange?: (level: ResultLevel) => void;
  onClose: () => void;
}) {
  const t = useT();
  return (
    <aside className="results-panel">
      <div className="results-panel-header">
        <h2>{t("topbar.results")}</h2>
        <button className="button-icon" onClick={onClose} aria-label={t("resultsPanel.close")}>
          ✕
        </button>
      </div>
      <div className="results-panel-body">
        <CalculationResults
          results={results}
          project={project}
          onChangeProject={onChangeProject}
          dates={dates}
          years={years}
          pumpingSeries={pumpingSeries}
          series={series}
          calculationOptions={calculationOptions}
          selection={selection}
          onSelect={onSelect}
          onLevelChange={onLevelChange}
        />
      </div>
    </aside>
  );
}
